export { default } from './MultiTextBoxes'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextBoxes/index.js